function toPascalCase(s: string): string {
  return s.replace(
    /(\w)(\w*)/g,
    (_, g1, g2) => g1.toUpperCase() + g2.toLowerCase()
  )
}

export default toPascalCase
